import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGrid } = FiIcons;

const LayoutConfig = ({ layoutWidth, setLayoutWidth }) => {
  const presets = [1080, 1280, 1440, 1920];

  return (
    <motion.div 
      className="bg-white rounded-[10px] p-8 shadow-sm border border-gray-100 flex flex-col h-full"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
    >
      <div className="flex items-center mb-8">
        <div className="mr-3 text-orange-400">
          <SafeIcon icon={FiGrid} className="text-xl" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">Konfiguration</h2>
      </div>

      <div className="flex-1 flex flex-col justify-center">
        <div className="flex justify-between items-end mb-2">
          <label className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 block">
            LAYOUT-BREITE
          </label>
        </div>

        <div className="relative mb-8">
          <div className="flex items-center justify-between mb-4">
             <span className="text-5xl font-black text-gray-900 tracking-tight">
              {layoutWidth}<span className="text-2xl text-gray-400 ml-1">px</span>
            </span>
          </div>
          
          <input
            type="range"
            min="320"
            max="2560"
            step="10"
            value={layoutWidth}
            onChange={(e) => setLayoutWidth(parseInt(e.target.value))}
            className="w-full h-2 rounded-full appearance-none cursor-pointer bg-gray-200 accent-[#FFA22A]"
          />
        </div>

        <div className="flex gap-4 mb-8">
          <div className="relative w-32">
             <input
                type="number"
                value={layoutWidth}
                onChange={(e) => setLayoutWidth(Math.max(0, parseInt(e.target.value) || 0))}
                className="w-full h-12 rounded-[6px] border border-gray-200 pl-4 pr-2 font-bold text-gray-900 focus:border-orange-400 outline-none transition-colors"
                placeholder="1080"
              />
          </div>
          <div className="flex flex-1 gap-2">
            {presets.map((preset) => (
              <button
                key={preset}
                onClick={() => setLayoutWidth(preset)}
                className={`flex-1 h-12 rounded-[6px] text-sm font-bold transition-all ${
                  layoutWidth === preset
                    ? 'bg-[#FFA22A] text-white shadow-md shadow-orange-200'
                    : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                }`}
              >
                {preset}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-gray-50 rounded-[6px] p-4 flex items-start">
          <div className="mt-0.5 mr-3 text-gray-400">
             <SafeIcon icon={FiGrid} className="text-sm" />
          </div>
          <p className="text-sm text-gray-500 leading-relaxed">
            Gebe einfach die Breite deines Layouts in Pixeln ein. Das Tool berechnet die perfekte Bildgröße für jede Spaltenanzahl.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default LayoutConfig;